import { useQuery } from '@tanstack/react-query'

import { ReservationDto } from '@wwt/entities/api/search-response'

import { getVoucherOptions } from '../options/getVoucherOptions'

export const useVoucher = (reservationId: ReservationDto['reservationId']) => {
	const queryData = useQuery(
		getVoucherOptions(reservationId, {
			// Disabled for refetch in event handler
			enabled: false,
			retry: false
		})
	)

	return queryData
}
